import { render } from "./DialogCalendar.vue?vue&type=template&id=10a82572&scoped=true"
import script from "./DialogCalendar.vue?vue&type=script&lang=js"
export * from "./DialogCalendar.vue?vue&type=script&lang=js"

import "./DialogCalendar.vue?vue&type=style&index=0&id=10a82572&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a82572"]])

export default __exports__